(() => {
  const format = cents => (cents / 100).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
  function init(root) {
    const isWechsel = root.dataset.mseTierKind === 'wechsel';
    const tiers = isWechsel ? [1, 10, 50] : [1, 10, 50, 100];
    const discounts = isWechsel ? [0, 15, 25] : [0, 15, 25, 35];
    if (root.dataset.mseInitialized === '1') return;
    const form = root.closest('form');
    const actual = form?.querySelector('[name="quantity"]');
    const displayed = root.querySelector('[data-mse-file-qty]');
    if (!form || !actual || !displayed) return;
    root.dataset.mseInitialized = '1';
    const grossBase = Number(root.dataset.baseGross);
    if (!Number.isSafeInteger(grossBase) || grossBase <= 0) return;
    const vatDivisor = Number(root.dataset.vatDivisor);
    if (!Number.isFinite(vatDivisor) || vatDivisor < 100 || vatDivisor > 130) return;
    const netFromGross = cents => Math.round(cents * 100 / vatDivisor);
    const price = qty => {
      let index = 0;
      for (let i = 0; i < tiers.length; i++) if (qty >= tiers[i]) index = i;
      const discountPerUnit = Math.floor(grossBase * discounts[index] / 100);
      const grossPerUnit = grossBase - discountPerUnit;
      return {index, net: netFromGross(grossPerUnit), gross: grossPerUnit};
    };
    tiers.forEach(q => {
      const p = price(q);
      root.querySelector('[data-tier-net="' + q + '"]').textContent = format(p.net);
      root.querySelector('[data-tier-gross="' + q + '"]').textContent = '(' + format(p.gross) + ' brutto)';
    });
    const get = () => Math.max(1, Math.floor(Number(actual.value) || 1));
    const render = () => {
      const qty = get(), p = price(qty);
      if (document.activeElement !== displayed) displayed.value = String(qty);
      root.querySelectorAll('[data-tier-qty]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.tierQty) === tiers[p.index])));
      root.querySelector('[data-mse-unit-net]').textContent = format(p.net);
      const grossTotal = p.gross * qty;
      root.querySelector('[data-mse-total-net]').textContent = format(netFromGross(grossTotal));
      root.querySelector('[data-mse-total-gross]').textContent = format(grossTotal);
      const next = tiers.find(q => q > qty);
      root.querySelector('[data-mse-file-next]').textContent = next ? 'Noch ' + (next - qty) + (isWechsel ? ' Tüten' : ' Stück') + ' bis zur nächsten Preisstufe.' : 'Beste Preisstufe erreicht.';
    };
    const set = qty => {
      qty = Math.max(1, Math.floor(Number(qty) || 1));
      if (actual.max && qty > Number(actual.max)) qty = Number(actual.max);
      actual.value = String(qty);
      displayed.value = String(qty);
      actual.dispatchEvent(new Event('input', {bubbles: true}));
      actual.dispatchEvent(new Event('change', {bubbles: true}));
      render();
    };
    root.querySelectorAll('[data-tier-qty]').forEach(b => b.addEventListener('click', () => set(b.dataset.tierQty)));
    root.querySelector('[data-mse-file-minus]').addEventListener('click', () => set(get() - 1));
    root.querySelector('[data-mse-file-plus]').addEventListener('click', () => set(get() + 1));
    displayed.addEventListener('input', () => { if (Number(displayed.value) >= 1) set(displayed.value); });
    displayed.addEventListener('change', () => set(displayed.value));
    actual.addEventListener('input', render);
    actual.addEventListener('change', render);
    form.classList.add('mse-file-tiers--active');
    render();
  }
  const boot = () => document.querySelectorAll('[data-mse-file-tiers]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();